const careers = () => {
	document
		.querySelectorAll('input[name="company-filter"]')
		.forEach(function (checkbox) {
			checkbox.addEventListener('change', function () {
				var selectedCompanies = Array.from(
					document.querySelectorAll('input[name="company-filter"]:checked')
				).map(function (input) {
					return input.value.replace(/\s+/g, '-').toLowerCase();
				});

				document.querySelectorAll('.careers__card').forEach(function (card) {
					var cardCompany = card.classList[1]; // assuming the second class is the company
					if (
						selectedCompanies.length === 0 ||
						selectedCompanies.includes(cardCompany)
					) {
						card.style.display = 'block';
					} else {
						card.style.display = 'none';
					}
				});
			});
		});
};

export default careers;
